import { render, staticRenderFns } from "./edit-leave.vue?vue&type=template&id=63cab8ea&"
import script from "./edit-leave.vue?vue&type=script&lang=js&"
export * from "./edit-leave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports